import { motion } from "framer-motion";
import { t } from "../i18n";
import { fadeUp, stagger, viewport } from "../motion";

export default function About() {
  const a = t.de.about;
  return (
    <section id="about" data-testid="about" className="relative py-24 md:py-36 bg-white">
      <div className="container mx-auto px-6 md:px-12 max-w-7xl">
        <div className="grid lg:grid-cols-2 gap-16 lg:gap-24 items-start">
          <div className="lg:sticky lg:top-32">
            <motion.div variants={stagger} initial="hidden" whileInView="show" viewport={viewport}>
              <motion.div variants={fadeUp} className="flex items-center gap-3 mb-6">
                <span className="h-px w-10 bg-gold-500" />
                <span className="text-xs font-semibold uppercase tracking-[0.25em] text-gold-600">{a.overline}</span>
              </motion.div>
              <motion.h2 variants={fadeUp} className="text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight text-navy-900 leading-tight text-balance">
                {a.title}
              </motion.h2>
              <motion.p variants={fadeUp} className="mt-6 text-lg text-slate-600 leading-relaxed max-w-md">
                {a.lead}
              </motion.p>
              <motion.div variants={fadeUp} className="mt-10 relative rounded-3xl overflow-hidden aspect-[4/5] max-w-sm">
                <img
                  src="https://images.pexels.com/photos/37320179/pexels-photo-37320179.jpeg"
                  alt="Glasfassade Hochhaus"
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 ring-1 ring-inset ring-navy-900/10 rounded-3xl" />
              </motion.div>
            </motion.div>
          </div>

          <motion.div variants={stagger} initial="hidden" whileInView="show" viewport={{ once: true, amount: 0.1 }} className="divide-y divide-slate-100">
            {a.values.map((v) => (
              <motion.div key={v.n} variants={fadeUp} className="py-7 group" data-testid={`value-${v.n}`}>
                <div className="flex items-start gap-6">
                  <span className="text-sm font-outfit font-medium text-gold-500 pt-1 tabular-nums">{v.n}</span>
                  <div>
                    <h3 className="text-xl md:text-2xl font-outfit font-medium text-navy-900 group-hover:text-gold-600 transition-colors">
                      {v.t}
                    </h3>
                    <p className="mt-2 text-slate-500 leading-relaxed">{v.d}</p>
                  </div>
                </div>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
}
